const BASELINE_GRID = 4

export const unitless = (value: number): number => BASELINE_GRID * value

export const unit = (value: number): string => `${unitless(value)}px`
